import { onboardingShownForScreen, logOnboardingShown } from "../../utils/onboarding";

const screenName = 'onboardingShownVideos';

const steps = [
    {
        img: '/images/onboarding/onboarding-crown.jpg',
        description: '<span style="font-size: 17px;">Use Videos by DentiCalc to <b>explain or compare</b> different dental treatments and convince your patients with the gains of the more expensive options.</span>',
        buttons: [
            {
                text: "Let's see the videos!",
                class: "primary",
                click: (ctx) => {
                    ctx.currentStep++;
                }
            }
        ],
        mounted: () => {
            logOnboardingShown(screenName);
        }
    }
]

export const onboarding = () => {
    return onboardingShownForScreen(screenName) === 0 ? steps : [];
}
